module.exports = __webpack_public_path__ + "static/media/button_up_hover.68a3595b.svg";